import React, { useEffect } from 'react';
import Banner from '../../components/Banner/Index';

const OPTIMIZADOR_URL = 'https://optimizadorlumadi.com.ar/';

const Optimizador = () => {
  useEffect(() => {
    window.location.replace(OPTIMIZADOR_URL);
  }, []);

  return (
    <>
      <Banner title='Optimizador'/>
      <div className='optimizador-section-container'>
        <div className='contenedor'>
          <p style={{ textAlign: 'center', padding: '40px 0' }}>
            Te estamos redirigiendo al optimizador...{' '}
            <a href={OPTIMIZADOR_URL} target='_blank' rel='noreferrer'>
              Hac&eacute; click ac&aacute; si no sucede autom&aacute;ticamente.
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default Optimizador;
